<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header">
      <h4 class="modal-title">Adjust your settings here.</h4>
      <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
  </div>
  <div class="modal-body">
    <form>
      <div class="form-group">
        <span class="label-header">Select your start state.</span>
        <ul>
          <li *ngFor="let opt of options.startStateKeys; let idx = index">
            <label (click)="saveStartState($event, idx)">
              <input
                type="radio"
                name="stumpy-start-state"
                [value]="opt.value"
                [checked]="idx === options.startState"
              >{{opt.label}}
            </label>
          </li>
        </ul>
      </div>
      <div class="form-group">
        <span class="label-header">Select your sword logic.</span>
        <ul>
          <li *ngFor="let opt of options.swordLogicKeys; let idx = index">
            <label (click)="saveSwordLogic($event, idx)">
              <input
                type="radio"
                name="stumpy-sword-logic"
                [value]="opt.value"
                [checked]="idx === options.swordLogic"
              >{{opt.label}}
            </label>
          </li>
        </ul>
      </div>
      <div class="form-group">
        <span class="label-header">Select your goal.</span>
        <ul>
          <li *ngFor="let opt of options.goalKeys; let idx = index">
            <label (click)="saveGoal($event, idx)">
              <input
                type="radio"
                name="stumpy-goal"
                [value]="opt.value"
                [checked]="idx === options.goal"
              >{{opt.label}}
            </label>
          </li>
        </ul>
      </div>
      <div class="form-group">
        <span class="label-header">Select your difficulty.</span>
        <ul>
          <li *ngFor="let opt of options.difficultyKeys; let idx = index">
            <label (click)="saveDifficulty($event, idx)">
              <input
                type="radio"
                name="stumpy-difficulty"
                [value]="opt.value"
                [checked]="idx === options.difficulty"
              >{{opt.label}}
            </label>
          </li>
        </ul>
      </div>
      <div class="form-group">
        <span class="label-header">Select the shuffling mode.</span>
        <ul>
          <li *ngFor="let opt of options.itemShuffleKeys; let idx = index">
            <label (click)="saveItemShuffle($event, idx)">
              <input
                type="radio"
                name="stumpy-item-shuffle"
                [value]="opt.value"
                [checked]="idx === options.itemShuffle"
              >{{opt.label}}
            </label>
          </li>
        </ul>
      </div>
      <div class="form-group">
        <span class="label-header">Show Go Mode label?</span>
        <ul>
          <li *ngFor="let opt of options.showGoModeKeys; let idx = index">
            <label (click)="saveGoMode($event, idx)">
              <input
                type="radio"
                name="stumpy-go-mode"
                [value]="opt.value"
                [checked]="idx === options.showGoMode"
              >{{opt.label}}
            </label>
          </li>
        </ul>
      </div>
      <div class="form-group">
        <span class="label-header">Select the enemy shuffle option (limited).</span>
        <ul>
          <li *ngFor="let opt of options.enemyKeys; let idx = index">
            <label (click)="saveEnemy($event, idx)">
              <input
                type="radio"
                name="stumpy-enemy"
                [value]="opt.value"
                [checked]="idx === options.enemy"
              >{{opt.label}}
            </label>
          </li>
        </ul>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-sm btn-outline-primary" (click)="c('Close click')">Close</button>
  </div>
</ng-template>

<button type="button" class="btn btn-outline-primary btn-sm" (click)="open(content)">
  <i class="fa fa-cog" aria-hidden="true"></i>
  Adjust your settings.
</button>

<!--
<select [(ngModel)]="options.logic">
  <option *ngFor="let c of options.logicKeys" value="{{c.value}}">{{c.label}}</option>
</select>
-->
